import axios from "axios";
import { useAuthStore } from "@/store/AuthStore";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    if (config.method !== "post" || config.url === "/auth/token") {
      return config;
    }

    const authStore = useAuthStore();

    if (authStore.token && config.headers) {
      config.headers.Authorization = `Bearer ${authStore.token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const authStore = useAuthStore();
      authStore.unsetToken();

      try {
        await authStore.setToken();

        return apiClient(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
